import React from 'react';
import { useI18n } from '@/i18n/I18nContext';
import { MonitorSmartphone, ShieldCheck } from 'lucide-react';

// Shown on phones / very small screens when the app is opened WITHOUT a secure
// share link. Editing is desktop-only; documents opened via a secure link can
// still be viewed read-only (see MobileViewer).
export const MobileBlock = () => {
  const { t } = useI18n();
  return (
    <div
      className="flex min-h-[100dvh] w-full flex-col items-center justify-center gap-5 bg-[#0F1115] px-7 py-10 text-center text-white"
      data-testid="mobile-block"
    >
      <div className="flex h-16 w-16 items-center justify-center rounded-2xl bg-white/10 ring-1 ring-white/15">
        <MonitorSmartphone className="h-8 w-8 text-white/90" />
      </div>
      <div>
        <p className="text-xs font-semibold uppercase tracking-[0.2em] text-[#6EA8FF]">SwitchR</p>
        <h1 className="mt-2 text-xl font-semibold leading-snug">{t('mobile_block_title')}</h1>
      </div>
      <p className="max-w-sm text-sm leading-relaxed text-white/70">{t('mobile_block_desc')}</p>
      <div className="mt-1 flex max-w-sm items-start gap-2 rounded-lg border border-white/10 bg-white/5 px-4 py-3 text-left text-xs leading-relaxed text-white/70">
        <ShieldCheck className="mt-0.5 h-4 w-4 shrink-0 text-[#34D399]" />
        <span>{t('mobile_block_share_hint')}</span>
      </div>
    </div>
  );
};
